import { createEffect, createSignal } from 'solid-js';
import { readPreferences, savePreferences, type DesktopTheme } from '../../lib/preferences';
import { PixelIcon } from '../PixelIcon';

interface SettingsWindowProps {
  close: () => void;
}

export function SettingsWindow(props: SettingsWindowProps) {
  const initial = readPreferences();
  const [theme, setTheme] = createSignal<DesktopTheme>(initial.theme);
  const [scale, setScale] = createSignal(initial.scale);
  const [grid, setGrid] = createSignal(initial.grid);

  createEffect(() => {
    savePreferences({ theme: theme(), scale: scale(), grid: grid() });
  });

  return (
    <div class="window-body app-window-body settings-window">
      <div class="settings-heading">
        <PixelIcon name="settings" size={44} />
        <div>
          <h1>Display Properties</h1>
          <p>Small preferences for this browser only.</p>
        </div>
      </div>

      <div class="tabs" role="tablist" aria-label="Display settings">
        <button aria-selected="true">Background</button>
        <button aria-selected="false" disabled>Appearance</button>
        <button aria-selected="false" disabled>Settings</button>
      </div>
      <div class="settings-tab-panel">
        <fieldset>
          <legend>Desktop color</legend>
          <div class="theme-options">
            <label>
              <input type="radio" name="theme" checked={theme() === 'teal'} onChange={() => setTheme('teal')} />
              <span class="theme-swatch theme-teal" /> Classic teal
            </label>
            <label>
              <input type="radio" name="theme" checked={theme() === 'navy'} onChange={() => setTheme('navy')} />
              <span class="theme-swatch theme-navy" /> Midnight blue
            </label>
            <label>
              <input type="radio" name="theme" checked={theme() === 'plum'} onChange={() => setTheme('plum')} />
              <span class="theme-swatch theme-plum" /> Research plum
            </label>
          </div>
        </fieldset>

        <fieldset>
          <legend>Interface scale</legend>
          <div class="field-row settings-scale-row">
            <label for="ui-scale">Size</label>
            <input
              id="ui-scale"
              type="range"
              min="0.85"
              max="1.2"
              step="0.05"
              value={scale()}
              onInput={(event) => setScale(Number(event.currentTarget.value))}
            />
            <output>{Math.round(scale() * 100)}%</output>
          </div>
        </fieldset>

        <label class="settings-checkbox">
          <input type="checkbox" checked={grid()} onChange={(event) => setGrid(event.currentTarget.checked)} />
          Show subtle workstation grid
        </label>
      </div>

      <div class="dialog-buttons">
        <button class="default" onClick={props.close}>OK</button>
      </div>
    </div>
  );
}
